import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useStyles } from '../TrackPage';

interface Price {
  displayText: string;
  name?: string;
}

interface TrackHeaderProps {
  imageUrl?: string;
  name: string;
  sourceName?: string;
  activePrices?: Price[];
  price?: Price;
  compDateDisplay?: string;
  compStatus?: string;
}

export const TrackHeader: React.FC<TrackHeaderProps> = ({
  imageUrl,
  name,
  sourceName,
  activePrices = [],
  price,
  compDateDisplay,
  compStatus,
}) => {
  const styles = useStyles();
  const displayName = name;
  const displayPrice =
    activePrices.length > 1
      ? `${activePrices[0].displayText} - ${
          activePrices[activePrices.length - 1].displayText
        }`
      : price?.displayText || '';

  return (
    <Box
      flexDirection="column"
      display="flex"
      justifyContent="center"
      alignItems="center"
      mb={4}
    >
      <Avatar className={styles.avatar} src={imageUrl} />
      {sourceName && sourceName !== name && (
        <Typography variant="h6" color="textSecondary">
          {sourceName}
        </Typography>
      )}
      <Typography variant="h4" component="h1" gutterBottom>
        {displayName}
      </Typography>
      <Box display="flex" flexWrap="wrap" justifyContent="center">
        {displayPrice && (
          <Typography variant="subtitle2" className={styles.badgeContainer}>
            {displayPrice}
          </Typography>
        )}
        {!!compDateDisplay &&
          !['in_progress', 'done'].includes(compStatus || '') && (
            <Typography variant="subtitle2" className={styles.badgeContainer}>
              {compDateDisplay}
            </Typography>
          )}
      </Box>
    </Box>
  );
};
